module.exports = __webpack_public_path__ + "img/DerTagAnDemFloydKam.c29b61f0.jpg";